<template>
    <div>
        <label>{{ label }}</label>
        <div style="position: relative; display: block; width: 100%; padding: 0 .25rem 1rem">
            <ui-select 
                :disabled="disabled"
                v-model="from" 
                style="width: 45%; display: inline-block;" 
                :options="fromRange"
                @input="change"
                placeholder="Any"
            >
                From
            </ui-select>
            <ui-select 
                :disabled="disabled"
                v-model="to" 
                style="width: 45%; display: inline-block;" 
                :options="toRange"
                @input="change"
                placeholder="Any"
            >
                To
            </ui-select>
        </div>
    </div>
</template>

<script>
    import Filters from '../../../filters'

    export default {
        filters: Filters,
        props: {
            label: {
                type: String,
                default: 'Priced Between',
            },
            value: {
                default: null,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            config: {
                type: Object,
                default() {
                    return {
                        mode: 'retail'
                    }
                }
            }
        },
        created() {
            this.setPriceFromValue();
        },
        watch: {
            value: {
                handler: function(n, o) {
                    if (n !== o) {
                        this.setPriceFromValue();
                    }
                }
            }
        },
        methods: {
            setPriceFromValue() {
                if (this.value && '%' !== this.value && typeof this.value === 'object') {
                    this.from = this.fromRange.find(item => item.value === this.value[0])
                    this.to = this.toRange.find(item => item.value === this.value[1])
                } else {
                    if (this.config.mode === 'monthly') {
                        this.from = { value: 0, label: '£0' }
                        this.to = { value: 9999999, label: '£1,000+' }
                    } else {
                        this.from = {value: 0, label: '£0'}
                        this.to = {value: 9999999, label: '£60,001+'}
                    }
                }
            },
            change() {
                if (this.from && this.to) {
                    this.$emit('input', [this.from.value, this.to.value])
                }
            }
        },
        computed: {
            fromRange() {
                if (this.config.mode === 'monthly') {
                    return [
                        {value: 0, label: '£0'},
                        {value: 50, label: '£50'},
                        {value: 100, label: '£100'},
                        {value: 150, label: '£150'},
                        {value: 200, label: '£200'},
                        {value: 250, label: '£250'},
                        {value: 300, label: '£300'},
                        {value: 350, label: '£350'},
                        {value: 400, label: '£400'},
                        {value: 450, label: '£450'},
                        {value: 500, label: '£500'},
                        {value: 550, label: '£550'},
                        {value: 600, label: '£600'},
                        {value: 1000, label: '£1,000'},
                    ]
                }

                return [
                    {value: 0, label: '£0'},
                    {value: 500, label: '£500'},
                    {value: 1000, label: '£1,000'},
                    {value: 1500, label: '£1,500'},
                    {value: 2000, label: '£2,000'},
                    {value: 2500, label: '£2,500'},
                    {value: 3000, label: '£3,000'},
                    {value: 3500, label: '£3,500'},
                    {value: 4000, label: '£4,000'},
                    {value: 4500, label: '£4,500'},
                    {value: 5000, label: '£5,000'},
                    {value: 5500, label: '£5,500'},
                    {value: 6000, label: '£6,000'},
                    {value: 6500, label: '£6,500'},
                    {value: 7000, label: '£7,000'},
                    {value: 7500, label: '£7,500'},
                    {value: 8000, label: '£8,000'},
                    {value: 8500, label: '£8,500'},
                    {value: 9000, label: '£9,000'},
                    {value: 9500, label: '£9,500'},
                    {value: 10000, label: '£10,000'},
                    {value: 11000, label: '£11,000'},
                    {value: 12000, label: '£12,000'},
                    {value: 13000, label: '£13,000'},
                    {value: 14000, label: '£14,000'},
                    {value: 15000, label: '£15,000'},
                    {value: 16000, label: '£16,000'},
                    {value: 17000, label: '£17,000'},
                    {value: 18000, label: '£18,000'},
                    {value: 19000, label: '£19,000'},
                    {value: 20000, label: '£20,000'},
                    {value: 22500, label: '£22,500'},
                    {value: 25000, label: '£25,000'},
                    {value: 30000, label: '£30,000'},
                    {value: 25000, label: '£25,000'},
                    {value: 30000, label: '£30,000'},
                    {value: 35000, label: '£35,000'},
                    {value: 40000, label: '£40,000'},
                    {value: 45000, label: '£45,000'},
                    {value: 50000, label: '£50,000'},
                    {value: 55000, label: '£55,000'},
                    {value: 60000, label: '£60,000'},
                ]
            },
            toRange() {
                if (this.config.mode === 'monthly') {
                    return [
                        {value: 0, label: '£0'},
                        {value: 50, label: '£50'},
                        {value: 100, label: '£100'},
                        {value: 150, label: '£150'},
                        {value: 200, label: '£200'},
                        {value: 250, label: '£250'},
                        {value: 300, label: '£300'},
                        {value: 350, label: '£350'},
                        {value: 400, label: '£400'},
                        {value: 450, label: '£450'},
                        {value: 500, label: '£500'},
                        {value: 550, label: '£550'},
                        {value: 600, label: '£600'},
                        {value: 99999, label: '£1,000+'},
                    ]
                }

                return [
                    { value: 500, label: '£500'},
                    { value: 1000, label: '£1,000'},
                    { value: 1500, label: '£1,500'},
                    { value: 2000, label: '£2,000'},
                    { value: 2500, label: '£2,500'},
                    { value: 3000, label: '£3,000'},
                    { value: 3500, label: '£3,500'},
                    { value: 4000, label: '£4,000'},
                    { value: 4500, label: '£4,500'},
                    { value: 5000, label: '£5,000'},
                    { value: 5500, label: '£5,500'},
                    { value: 6000, label: '£6,000'},
                    { value: 6500, label: '£6,500'},
                    { value: 7000, label: '£7,000'},
                    { value: 7500, label: '£7,500'},
                    { value: 8000, label: '£8,000'},
                    { value: 8500, label: '£8,500'},
                    { value: 9000, label: '£9,000'},
                    { value: 9500, label: '£9,500'},
                    { value: 10000, label: '£10,000'},
                    { value: 11000, label: '£11,000'},
                    { value: 12000, label: '£12,000'},
                    { value: 13000, label: '£13,000'},
                    { value: 14000, label: '£14,000'},
                    { value: 15000, label: '£15,000'},
                    { value: 16000, label: '£16,000'},
                    { value: 17000, label: '£17,000'},
                    { value: 18000, label: '£18,000'},
                    { value: 19000, label: '£19,000'},
                    { value: 20000, label: '£20,000'},
                    { value: 22500, label: '£22,500'},
                    { value: 25000, label: '£25,000'},
                    { value: 30000, label: '£30,000'},
                    { value: 25000, label: '£25,000'},
                    { value: 30000, label: '£30,000'},
                    { value: 35000, label: '£35,000'},
                    { value: 40000, label: '£40,000'},
                    { value: 45000, label: '£45,000'},
                    { value: 50000, label: '£50,000'},
                    { value: 55000, label: '£55,000'},
                    { value: 60000, label: '£60,000'},
                    { value: 9999999, label: '£60,001+'}
                ]
            },
        },
        data() {
            return {
                from: { value: 0, label: '£0' },
                to: { value: 9999999, label: '£60,001+' },
            }
        }
    }
</script>